module.exports = __webpack_public_path__ + "static/media/fly0198.897749eb.webp";